import { Tabs, Modal, Button, message } from "antd";
import React, { useState, useEffect } from "react";
import MenuBar from "./menu/MenuBar";
import Total from "./account/Total";
import { gotoMakePDF } from "./account/gotoPDF";
import MakeDocLong from "./pdf/MakeDocLong";
import MakeDocSafty from "./pdf/MakeDocSafty";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import { PDFDownloadLink } from "@react-pdf/renderer";
import PDFReport from "./account/PDFReport_2";
import { pad, postData } from "../data/allfunction";
import { delUser, setUser } from "../app/features/user/userSlice";
import { useHistory } from "react-router-dom";

import ShowModalPolicy from "./modalPolicy/ShowModalPolicy";
import TotalNo from "./account/TotalNo";
import ExportEcell from "./account/Export_Ecell";
import Total_2 from "./account/Total_2";
import TotalNo_2 from "./account/TotalNo_2";
import ExportEcell_2 from "./account/Export_Ecell_2";
import Export_Ecell_2_End from "./account/Export_Ecell_2_End";
import { changLgValue } from "../data/allfunction_2";


const ip = process.env.REACT_APP_IP;
const { TabPane } = Tabs;
function AccountFinance() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { user, token, retoken } = useSelector((state) => {
    return state.user;
  });
  const { value } = useSelector((state) => state.lg);
  const [modalShow, setModalShow] = useState(false);
  const [datasentPDF, setdatasentPDF] = useState({});
  const [thirdcover_option, setthirdcover_option] = useState([]);
  const [drivercover_option, setdrivercover_option] = useState([]);
  const [pdfDatas, setpdfDatas] = useState(true);
  const [modal_show_alldetail, setmodal_show_alldetail] = useState(false);
  const [getOneFull, setgetOneFull] = useState({});
  const [no, setno] = useState(null);
  //ດິງຂໍ້ມູນປະເພດ ອ້ອບຊັ່ນບຸກຄຸນທີສາມ
  useEffect(() => {
    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };

    // fetch(ip + "sell_online/thirdcover_option", requestOptions)
    fetch(ip + "sell_online/cover_third_tariff", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setthirdcover_option(result.data.data);
      })
      .catch((error) => console.log("error", error));
  }, []);

  function showModalDetail(no) {
    setno(no);
    setmodal_show_alldetail(true);
    getDataOneFull(no);
  }
  function getDataOneFull(no) {
    console.log("getDataOneFull");
    let link = `${ip}sell_online/getOneFull`;
    let dataSetForGet = { no: no };
    function setWhenUpdate(result) {
      // setloading(true)
      if (result.data.status === 200) {
        const { rows } = result.data;

        if (rows.length > 0) {
          let de = rows.map((e) => {
            return e;
          });
          setgetOneFull(de[0]);
        } else {
          setgetOneFull({});
        }
        setTimeout(() => {
          // setloading(false)
        }, 100);
      } else {
        setTimeout(() => {
          // setloading(false)
        }, 100);
      }
    }
    postData(
      message,
      link,
      dataSetForGet,
      token,
      retoken,
      user,
      dispatch,
      delUser,
      setUser,
      history,
      setWhenUpdate
    );
  }

  return (
    <>
      <MenuBar />
      <div className="container text-center mt-3">
        <h4>
          {/* ລາຍງານການຂາຍປະກັນໄພທັງໝົ້ດ */}
          {changLgValue(value,92)}
        </h4>
      </div>
      <div className="container-fluid">
        <Tabs defaultActiveKey="1">
          <TabPane 
          // tab="ລາຍງານສັນຍາທັງໝົ້ດຕາມຕົວແທນ" 
          tab={changLgValue(value,67)}
          key="1">
            {/* <Total
                            setdatasentPDF={setdatasentPDF}
                            setModalShow={setModalShow}
                            button_pfd={button_pfd}
                            showModalDetail={showModalDetail}
                            setdrivercover_option={setdrivercover_option}
                        /> */}
            <Total_2
              setdatasentPDF={setdatasentPDF}
              setModalShow={setModalShow}
              button_pfd={button_pfd}
              showModalDetail={showModalDetail}
              setdrivercover_option={setdrivercover_option}
            />
          </TabPane>
          <TabPane 
          // tab="ລາຍງານສັນຍາທັງໝົ້ດຕາມເລກທີສັນຍາ" 
          tab={changLgValue(value,68)}
          key="2">
            <TotalNo_2
              setdatasentPDF={setdatasentPDF}
              setModalShow={setModalShow}
              button_pfd={button_pfd}
              showModalDetail={showModalDetail}
              setdrivercover_option={setdrivercover_option}
            />

            {/* <TotalNo
              setdatasentPDF={setdatasentPDF}
              setModalShow={setModalShow}
              button_pfd={button_pfd}
              showModalDetail={showModalDetail}
              setdrivercover_option={setdrivercover_option}
            /> */}
          </TabPane>
          <TabPane 
          // tab="ສ້າງລາຍງານເປັນເອັກແຊວ" 
          tab={changLgValue(value,69)}
          key="3">
            <ExportEcell_2
              setdatasentPDF={setdatasentPDF}
              setModalShow={setModalShow}
              button_pfd={button_pfd}
              showModalDetail={showModalDetail}
              setdrivercover_option={setdrivercover_option}
            />
          </TabPane>

          <TabPane 
          // tab="ສ້າງລາຍງານສັນຍາທີ່ຈະໝົ້ດການຄຸ້ມກັນ" 
          tab={changLgValue(value,70)}
          key="4">
            <Export_Ecell_2_End
              setdatasentPDF={setdatasentPDF}
              setModalShow={setModalShow}
              button_pfd={button_pfd}
              showModalDetail={showModalDetail}
              setdrivercover_option={setdrivercover_option}
            />
          </TabPane>

          
        </Tabs>
      </div>
      <Modal
        width={720}
        title={"ລາຍລະອຽດຂອງສັນຍາເລກທີ " + pad(datasentPDF.no)}
        visible={modalShow}
        onOk={() => setModalShow(false)}
        onCancel={() => setModalShow(false)}
        footer={[
          <Button key="back" onClick={() => setModalShow(false)}>
            ກັບຄືນ
          </Button>,
        ]}
      >
        <>
          <div></div>
          {gotoMakePDF(datasentPDF.cover) === "L" ? (
            <MakeDocLong
              no={datasentPDF.no}
              user={user}
              oneData={datasentPDF}
              thirdcover_option={thirdcover_option}
              drivercover_option={drivercover_option}
            />
          ) : gotoMakePDF(datasentPDF.cover) === "S" ? (
            <MakeDocSafty no={datasentPDF.no} oneData={datasentPDF} />
          ) : (
            <>{gotoMakePDF(datasentPDF.cover)}</>
          )}
        </>
      </Modal>

      <ShowModalPolicy
        no={no}
        modal_show_alldetail={modal_show_alldetail}
        setmodal_show_alldetail={setmodal_show_alldetail}
        getOneFull={getOneFull}
      />
    </>
  );

  function button_pfd(
    user,
    datas,
    total_premuim,
    premuim,
    commission,
    ZJIIncom,
    ZJItax,
    countCancle,
    sent_startCover,
    sent_endCover,
    sent_user_name,
    where
  ) {
    if (pdfDatas) {
      return (
        <Button
          type="primary"
          style={{
            background: "#FCF3CF",
            borderColor: "#F7DC6F",
            color: "#566573",
          }}
          onClick={() => setpdfDatas(!pdfDatas)}
        >
          ສ້າງ PDF
        </Button>
      );
    } else {
      return (
        <Button type="primary" onClick={() => setpdfDatas(!pdfDatas)}>
          <PDFDownloadLink
            document={
              <PDFReport
                user={user}
                datas={datas}
                total_premuim_ConfirmS={total_premuim}
                premuim_ConfirmS={premuim}
                commission_ConfirmS={commission}
                ZJIIncom_ConfirmS={ZJIIncom}
                ZJItax_ConfirmS={ZJItax}
                countCancle_ConfirmS={countCancle}
                policy_no_start={sent_startCover}
                policy_no_end={sent_endCover}
                sent_user_name={sent_user_name}
                where={where}
              />
            }
            fileName={
              "ລາຍລະອຽດຕົວແທນ " +
              sent_user_name +
              "/" +
              user +
              moment(Date.now()).format("DD-MM-YYYY") +
              ".pdf"
            }
          >
            {({ blob, url, loading, error }) =>
              loading ? "ກຳລັງກະກຽມ..." : "ລາຍງານເປັນ PDF"
            }
          </PDFDownloadLink>
        </Button>
      );
    }
  }
}
export default AccountFinance;
